const Footer = () => {
    return (
        <footer className="border-top footer text-muted py-4">
            <div className="container">
                &copy; {new Date().getFullYear()} - TraCuuDiemThiViDo
            </div>
            <br/>
            <div className="container">
                Nguồn Báo <a href="https://vietnamnet.vn/huong-dan-tra-cuu-diem-thi-lop-10-nam-2023-cua-tp-hcm-2156111.html">Vietnamnet.vn</a>
            </div>
        </footer>
    )
}

export default Footer;